"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconGradCap = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "GradCap" }, props),
        react_1.default.createElement("title", null, "Grad Cap"),
        react_1.default.createElement("path", { d: "M15 90.171a6.429 6.429 0 100-12.857 6.429 6.429 0 000 12.857z", fill: "#000" }),
        react_1.default.createElement("path", { d: "M17.571 47.968h-5.143v38.09h5.143v-38.09zM25.714 47.1V90S37.79 98.57 60 98.57C84.343 98.571 94.286 90 94.286 90V47.1", fill: "#000" }),
        react_1.default.createElement("path", { d: "M25.714 54.257V90S37.79 98.57 60 98.57V54.257", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M111.429 47.1L60 21.428 8.571 47.1 60 72.857 111.429 47.1z", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M8.571 47.1L60 72.857 111.429 47.1", fill: "#D44513" })));
};
exports.default = BrandIconGradCap;
